export const homeURL = "/";
export const termsandconditionURL = "/terms-and-conditions";
export const privacypolicyURL = "/privacy-policy";
export const thankyouURL = "/thank-you";
export const winnersURL = "/winners";
